import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { ReportsListNewElements } from './ReportsListNewElements';
import { Popup } from 'src/components/Popup/Popup';
import Loading from 'src/components/Loading';

export const ReportsListNew = observer(() => {
    const { reduxReportState } = useAppStateContext();
    const { reportsListId } = reduxReportState;
    return (
        <div className='reports-list'>
            {reportsListId.length > 0 ? (
                <table className='reports-list-table table__striped'>
                    <thead>
                        <tr>
                            <th>Creation date</th>
                            <th>Date range</th>
                            <th>Status</th>
                            <th />
                        </tr>
                    </thead>

                    <ReportsListNewElements />
                </table>
            ) : null}

            {reduxReportState.viewerContent === null ? null : (
                <Popup
                    title='Report viewer'
                    className='reports-list-viewer'
                    active={true}
                    onClose={reduxReportState.closeViewer}
                >
                    <iframe src={reduxReportState.viewerContent} />
                </Popup>
            )}

            <Loading
                active={reduxReportState.isLoading}
                message='Loading reports...'
            />
        </div>
    );
});
